import React, { useState } from "react";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CheckIcon from "@material-ui/icons/Check";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ImageIcon from "@material-ui/icons/Image";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { grey, blueGrey, red, yellow, green } from "@material-ui/core/colors";
import consts from "../../main/consts";
import Eans from "./Eans/Eans";
import {
  Tooltip,
  Link,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  Typography,
  Avatar,
  Checkbox,
  TextField,
  Stepper,
  Step,
  StepLabel,
  Grid,
  useMediaQuery,
  FormControlLabel,
  Divider,
  Radio,
  FormControl,
  RadioGroup,
} from "@material-ui/core";
import clsx from "clsx";
import { ORIGEM } from "../../main/origem";
import { useDispatch, useSelector } from "react-redux";
import {
  getReasonsForCancellation,
  atualizarEstoque,
} from "../../state/order/actions";
import { validateImei } from "../../utils/validateImei";
import Accordion from "@material-ui/core/ExpansionPanel";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
import MinimizeIcon from "@material-ui/icons/Remove";
import ExpandIcon from "@material-ui/icons/Add";
import AccordionDetails from "@material-ui/core/ExpansionPanelDetails";
import Skeleton from "@material-ui/lab/Skeleton";

import { StorageUser } from "../../main/StorageUser";

import Authorization from "./Authorization";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "auto",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    color: grey[800],
  },
  contentInfo: {
    borderBottom: `1px solid ${grey[200]}`,
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(3),
  },
  listContent: {
    borderBottom: `1px solid ${grey[200]}`,
    maxHeight: "50vh",
    [theme.breakpoints.down("xs")]: {
      maxHeight: "inherit !important",
    },
  },
  contentListItens: {
    padding: 0,
  },
  item: {
    alignItems: "start",
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    borderBottom: "1px dashed #CCC",
    color: grey[800],
    "&:last-child": {
      borderBottom: 0,
    },
  },
  marginTop5: {
    marginTop: 5,
  },
  marginTop10: {
    marginTop: 10,
  },
  rounded: {
    marginTop: 3,
    color: grey[400],
    backgroundColor: grey[200],
    width: 50,
    height: 50,
    border: `1px solid ${grey[200]}`,
  },
  quantityField: {
    marginLeft: theme.spacing(2),
  },
  price: {
    textAlign: "right",
  },
  priceTotal: {
    textAlign: "right",
    color: "#12cd0b",
    fontWeight: "bold",
  },
  button: {
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0,
      paddingLeft: 0,
    },
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid #EEE",
    border: "none",
  },
  textField: {
    marginTop: 15,
  },
  buttonOk: {
    marginLeft: 16,
    backgroundColor: blueGrey[900],
    color: "#fff",
    "&:hover": {
      backgroundColor: blueGrey[800],
    },
  },
  buttonRecusar: {
    marginLeft: 16,
  },
  action: {
    padding: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  linkContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
  },
  link: {
    marginTop: theme.spacing(1),
    alignSelf: "center",
  },
  info: {
    width: 36,
    height: 36,
    backgroundColor: blueGrey[50],
    marginRight: theme.spacing(1),
  },
  infoIcon: {
    color: blueGrey[600],
  },
  steppedContent: {
    borderBottom: `1px solid ${grey[200]}`,
    paddingBottom: theme.spacing(1),
  },
  btnNot: {
    marginRight: theme.spacing(2),
  },
  backButton: {
    zIndex: 99999,
    position: "absolute",
    left: 10,
    top: 20,
  },
  fieldImei: {
    paddingLeft: theme.spacing(2),
  },
  descricao: {
    lineHeight: 1.3,
  },
  nenhumItem: {
    backgroundColor: red[100],
    opacity: 0.75,
  },
  algunsItens: {
    backgroundColor: yellow[100],
  },
  todosItens: {
    backgroundColor: green[100],
  },
  checkboxTodosItens: {
    color: `${green[600]} !important`,
  },
  checkboxAlgunsItens: {
    color: `${yellow[700]} !important`,
  },
  labelEstoque: {
    padding: "1px 8px",
    borderRadius: 6,
    color: "#FFFF",
    fontWeight: "bold",
    textAlign: "right",
  },
  green: { backgroundColor: "#12cd0b" },
  red: { backgroundColor: "#dc392c" },
  orange: { backgroundColor: "#fbc700" },
  boxEstoque: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: 12,
    marginBottom: 12,
  },
  accordionItem: {
    border: 0,
    boxShadow: "none",
    padding: 0,
  },
  accordionSummary: {
    padding: 0,
  },
  accordionIcon: {
    color: "#F80032",
    marginRight: "10px",
  },
  contentHeader: {
    display: "flex",
  },
}));

export default function ConfirmarEstoqueModal(props) {
  const {
    open,
    handleClose,
    order,
    itens,
    imeis,
    handleConfirmacao,
    handlerRecusa,
  } = props;

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const { reasons = [] } = useSelector((state) => state.orders);

  const [selectedItens, setSelectedItens] = React.useState([]);
  const [activeStep, setActiveStep] = React.useState(0);
  const [hasEdition, setHasEdition] = React.useState(false);
  const [hasImei, setHasImei] = React.useState(false);
  const [recusar, setRecusar] = React.useState(false);
  const [validated, setValidated] = React.useState(true);
  let validationCheck = true;

  const [reason, setReason] = useState("");
  const [expanded, setExpanded] = useState("");

  const storageUser = new StorageUser();

  const requireAutorizador = storageUser.allowedByPermission(
    "INLINE_CANCEL_CONFIRM"
  );

  const handleChange = (event) => {
    setReason(event.target.value);
  };

  const handleChangeAccordion = (value) => {
    setExpanded(value === expanded ? "" : value);
  };

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (open) {
      dispatch(atualizarEstoque(order.numero));
      dispatch(
        getReasonsForCancellation({
          origem: order.origem,
          status: order.status,
        })
      );
    }
  }, [open]);

  const handleCheckRecusa = (recusa) => {
    if (recusa) {
      dispatch(
        getReasonsForCancellation({
          origem: order.origem,
          status: order.status,
        })
      );
      setSelectedItens([]);
    } else {
      resetSelectedItens();
    }

    setRecusar(recusa);
  };

  const handleConclusao = ({ nomeAutorizador, emailAutorizador } = {}) => {
    recusar
      ? handlerRecusa()
      : handleConfirmacao({
          hasEdition,
          selectedItens,
          hasImei,
          reason,
          nomeAutorizador,
          emailAutorizador,
        });
    resetSelectedItens();
    handleClose();
    setActiveStep(0);
  };

  const checkHasEdition = () => {
    let edited = false;
    itens.map((x, i) => {
      const codigoItem = x.codigoEAN + "_" + i;
      let sel = selectedItens.filter((s) => s.codigoEAN === codigoItem);
      if (sel.length && x.quantidade !== sel[0].quantidade) {
        edited = true;
        x.quantidadeTotal = sel[0].quantidade;
      } else {
        x.quantidadeTotal = x.quantidade;
      }
      return x;
    });
    setHasEdition(edited);
  };

  const checkRecusaPorQtde = () => {
    let recusa = true;

    itens.map((x, i) => {
      const codigoItem = x.codigoEAN + "_" + i;
      let sel = selectedItens.filter((s) => s.codigoEAN === codigoItem);
      if (sel.length && sel[0].quantidade !== 0) {
        recusa = false;
      }
      return x;
    });

    if (recusa) {
      dispatch(
        getReasonsForCancellation({
          origem: order.origem,
          status: order.status,
        })
      );
      setSelectedItens([]);
    }
    setRecusar(recusa);
  };

  const handleCheckItens = (codigo, qtd, imeis = [[]]) => {
    const item = { codigoEAN: codigo, quantidade: qtd, imeis: imeis };
    const hasExist = selectedItens.filter((x) => x.codigoEAN === codigo).length;
    const novosItens = hasExist
      ? selectedItens.filter((x) => x.codigoEAN !== codigo)
      : [...selectedItens, item];

    setSelectedItens(novosItens);

    const temImei = novosItens.some(
      (x) => x.imeis && x.imeis.toString().replace(/,/gi, "").length
    );
    setHasImei(temImei);
  };

  const valueQuantidade = (codigo, qtd) => {
    let item = selectedItens.filter((x) => x.codigoEAN === codigo);
    if (item.length > 0) return item[0].quantidade;
    return qtd;
  };

  const valueImei = (codigo, i, j) => {
    var item = selectedItens.filter((x) => x.codigoEAN === codigo);
    if (item && item.length) {
      item = item[0];
      if (item) {
        if (item && item.imeis.length) return item.imeis[i][j] || "";
      }
    }
    return "";
  };

  const resetSelectedItens = () => {
    setTimeout(() => {
      setHasImei(false);
      setSelectedItens([]);
      setHasEdition(false);
      setRecusar(false);
    }, 200);
  };

  const handleChangeQtde = (codigo, qtd, max) => {
    qtd = qtd ? parseInt(qtd) : null;
    max = parseInt(max);

    const _itens = selectedItens.map((x) => {
      if (x.codigoEAN === codigo) {
        x.quantidade = qtd >= max ? max : qtd;
      }
      return x;
    });
    setSelectedItens(_itens);
  };

  const handleChangeImei = (codigo, i, j, valorImei) => {
    const _itens = selectedItens.map((x) => {
      if (x.codigoEAN === codigo) {
        x.imeis[i][j] = valorImei;
      }
      return x;
    });
    setSelectedItens(_itens);

    const temImei = _itens.some(
      (x) => x.imeis && x.imeis.toString().replace(/,/gi, "").length
    );
    setHasImei(temImei);
  };

  const getQtdeTotal = () => {
    let qtd = 0;
    selectedItens.map((x) => (qtd += x.quantidade));
    return qtd > 1 ? `${qtd} itens` : `${qtd} item`;
  };

  const textEstoque = (item) => {
    if (
      item.estoque >= item.quantidade ||
      (item.estoque > 0 && item.estoque < item.quantidade)
    ) {
      return (
        <Typography
          variant="subtitle2"
          className={[classes.labelEstoque, classes.green]}
        >
          Estoque estimado: {item.estoque}
        </Typography>
      );
    }
  };

  const getInfoDescription = () => {
    if (order.origem === "CATALOGO")
      return (
        <div className={classes.contentInfo}>
          <Box flexGrow={1} display="flex" p={0}>
            <Box flexGrow={1}>
              <Avatar className={classes.info}>
                <ErrorOutlineIcon
                  className={classes.infoIcon}
                  fontSize="default"
                />
              </Avatar>
            </Box>
            <Box>
              <Typography variant="subtitle2">
                Qualquer <b>ADIÇÃO</b> ou <b>ALTERAÇÃO</b> de itens, deve ser
                realizada em um novo pedido no catálogo.{" "}
                <Tooltip title="O Catálogo é um sistema separado do Maestro (abrirá em nova aba)">
                  <Link
                    href={consts.CATALOGO_URL || "/"}
                    target="_blank"
                    className="font-bold"
                  >
                    Acessar o Catálogo
                  </Link>
                </Tooltip>
              </Typography>
            </Box>
          </Box>
        </div>
      );
    return "";
  };

  function renderContentItens() {
    return (
      <>
        <div className={classes.contentInfo}>
          <Typography variant="h6">
            Confirme os itens do pedido #{order.numero}.
          </Typography>
          <Typography variant="subtitle2">
            Marque cada item para confirmar o estoque e informe quantidade
            disponível.
          </Typography>
        </div>

        <DialogContent
          className={clsx(
            classes.listContent,
            classes.contentListItens,
            recusar ? classes.nenhumItem : ""
          )}
        >
          {itens &&
            itens.map((item, indexItem) => {
              const codigoItem = item.codigoEAN + "_" + indexItem;
              const qtd = valueQuantidade(codigoItem, item.quantidade);
              return (
                <div
                  key={codigoItem}
                  className={clsx(
                    classes.item,
                    { [classes.nenhumItem]: qtd === 0 },
                    { [classes.algunsItens]: qtd > 0 && qtd < item.quantidade },
                    {
                      [classes.todosItens]:
                        qtd === item.quantidade &&
                        selectedItens.filter((x) => x.codigoEAN === codigoItem)
                          .length,
                    }
                  )}
                >
                  <Box display="flex" p={0}>
                    <Box width={40} minWidth={40}>
                      <Checkbox
                        disabled={recusar}
                        className={clsx(
                          classes.marginTop5,
                          {
                            [classes.checkboxAlgunsItens]:
                              qtd > 0 && qtd < item.quantidade,
                          },
                          {
                            [classes.checkboxTodosItens]:
                              qtd === item.quantidade &&
                              selectedItens.filter(
                                (x) => x.codigoEAN === codigoItem
                              ).length,
                          }
                        )}
                        onChange={() =>
                          handleCheckItens(
                            codigoItem,
                            item.quantidade,
                            imeis[indexItem] || []
                          )
                        }
                        checked={
                          selectedItens.filter(
                            (x) => x.codigoEAN === codigoItem
                          ).length
                            ? true
                            : false
                        }
                        name={codigoItem}
                        color="primary"
                      />
                    </Box>
                    <Box width={60} minWidth={60}>
                      <Typography variant="h6" className={classes.marginTop10}>
                        {item.quantidade}x
                      </Typography>
                    </Box>

                    <Box width={66} minWidth={66}>
                      <Avatar
                        variant="rounded"
                        className={classes.rounded}
                        src={item.imageUrl}
                      >
                        <ImageIcon fontSize="large" />
                      </Avatar>
                    </Box>
                    <Box flexGrow={1}>
                      <Typography
                        variant="subtitle2"
                        className={classes.descricao}
                      >
                        {item.descricao}
                      </Typography>
                      <Eans eans={item.eans} codigoEAN={item.codigoEAN} />
                      <Typography variant="body2">
                        <b>SAP:</b> {item.codigoSAP}
                      </Typography>
                      <Box className={classes.boxEstoque}>
                        {textEstoque(item)}
                      </Box>
                    </Box>
                    <Box
                      width={90}
                      minWidth={90}
                      className={classes.quantityField}
                    >
                      <TextField
                        fullWidth
                        label="Qtde"
                        variant="outlined"
                        disabled={
                          selectedItens.filter(
                            (x) => x.codigoEAN === codigoItem
                          ).length
                            ? false
                            : true
                        }
                        onChange={(e) => {
                          handleChangeQtde(
                            codigoItem,
                            e.target.value,
                            item.quantidade
                          );
                        }}
                        value={qtd}
                        inputProps={{
                          type: "number",
                          max: item.quantidade,
                          min: 0,
                          length: 3,
                        }}
                        helperText="Disponível"
                        margin="dense"
                      />
                    </Box>
                  </Box>
                  {!recusar &&
                    imeis.length > 0 &&
                    item.quantidadeImeis > 0 &&
                    imeis[indexItem].map((itemQtde, i) => {
                      return (
                        i < qtd &&
                        item.quantidadeImeis > 0 && (
                          <Box
                            display="flex"
                            p={0}
                            key={item.codigoEAN + "_" + i}
                          >
                            <Box width={84} minWidth={84}>
                              <Typography
                                className={classes.marginTop10}
                                variant="subtitle1"
                                align="center"
                              >
                                Item {i + 1}
                              </Typography>
                            </Box>
                            <Box flexGrow={1}>
                              <Grid container spacing={0}>
                                {itemQtde.length > 0 &&
                                  itemQtde.map((imei, j) => {
                                    const value = valueImei(codigoItem, i, j);
                                    const validationError =
                                      !validateImei(value);
                                    const disabled = selectedItens.filter(
                                      (x) => x.codigoEAN === codigoItem
                                    ).length
                                      ? recusar
                                        ? true
                                        : false
                                      : true;
                                    if (validationError)
                                      validationCheck = false;

                                    return (
                                      <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        key={imei[i] + "_" + i + "_" + j}
                                        className={classes.fieldImei}
                                      >
                                        <TextField
                                          disabled={disabled}
                                          fullWidth
                                          label={"IMEI " + (j + 1)}
                                          variant="outlined"
                                          onChange={(e) => {
                                            handleChangeImei(
                                              codigoItem,
                                              i,
                                              j,
                                              e.target.value
                                            );
                                          }}
                                          value={value}
                                          margin="dense"
                                          error={!disabled && validationError}
                                          required
                                          inputProps={{
                                            maxLength: 18,
                                          }}
                                          onInput={(e) => {
                                            e.target.value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                          }}
                                        />
                                        {value && validationError && (
                                          <Typography
                                            variant="subtitle2"
                                            color={"error"}
                                            className={classes.descricao}
                                          >
                                            IMEI inválido.
                                          </Typography>
                                        )}
                                      </Grid>
                                    );
                                  })}
                              </Grid>
                            </Box>
                          </Box>
                        )
                      );
                    })}
                </div>
              );
            })}
        </DialogContent>

        {[
          ORIGEM.SHIP_FROM_STORE,
          ORIGEM.PEGUE_NA_LOJA_HOJE,
          ORIGEM.BOTMAKER,
        ].includes(order.origem) && (
          <div className={classes.contentInfo} align={"center"}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={recusar}
                  onChange={() => {
                    handleCheckRecusa(!recusar);
                  }}
                  color="primary"
                />
              }
              label={
                <Typography variant="subtitle2" color={"primary"}>
                  A loja não possui nenhum item.
                </Typography>
              }
            />
          </div>
        )}

        {getInfoDescription()}
      </>
    );
  }

  function renderContentResumo() {
    if (recusar) {
      return (
        <DialogContent className={classes.listContent}>
          <Box p={1}>
            <Typography
              align="center"
              variant="h6"
              color="secondary"
              className="center"
            >
              ATENÇÃO!
            </Typography>
          </Box>
          <Box p={1}>
            <Typography align="center" variant="subtitle1">
              A loja não possui nenhum item?
            </Typography>
          </Box>
        </DialogContent>
      );
    }
    return (
      <DialogContent className={classes.listContent}>
        <Box p={1}>
          {hasEdition ? (
            <Typography align="center" variant="subtitle1">
              <b>Confirmação Parcial</b> de {getQtdeTotal()}. Selecione o motivo
              para o(s) produto(s) recusado(s):
            </Typography>
          ) : (
            <React.Fragment>
              <Box p={1}>
                <Typography
                  align="center"
                  variant="h6"
                  color="secondary"
                  className="center"
                >
                  ATENÇÃO!
                </Typography>
              </Box>
              <Typography align="center" variant="subtitle1">
                Você afirma ter separado <b>{getQtdeTotal()}</b>?
              </Typography>
            </React.Fragment>
          )}
        </Box>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            aria-label="Motivo"
            name="reason"
            value={reason}
            onChange={handleChange}
          >
            {hasEdition &&
              reasons.map((item, index) => (
                <React.Fragment key={item.code}>
                  {item.subItems.length > 0 ? (
                    <Accordion
                      expanded={item.code === expanded}
                      onChange={() => handleChangeAccordion(item.code)}
                      className={classes.accordionItem}
                    >
                      <AccordionSummary
                        className={classes.accordionSummary}
                        aria-controls={`subitems-${item.code}`}
                        id={item.code}
                      >
                        {item.code === expanded ? (
                          <MinimizeIcon className={classes.accordionIcon} />
                        ) : (
                          <ExpandIcon className={classes.accordionIcon} />
                        )}
                        <Typography>{item.description}</Typography>
                      </AccordionSummary>
                      <Divider />
                      <AccordionDetails>
                        <Box flexGrow={1} display="grid">
                          {item.subItems.map((subItem, index) => (
                            <React.Fragment key={subItem.code}>
                              <FormControlLabel
                                value={subItem.code}
                                selected={subItem.code === reason}
                                control={<Radio />}
                                label={subItem.description}
                              />
                              {index + 1 !== item.subItems.length && (
                                <Divider />
                              )}
                            </React.Fragment>
                          ))}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  ) : (
                    <FormControlLabel
                      value={item.code}
                      selected={item.code === reason}
                      control={<Radio />}
                      label={item.description}
                    />
                  )}
                  {index + 1 !== reasons.length && <Divider />}
                </React.Fragment>
              ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
    );
  }

  const handleNext = () => {
    if (validated) {
      checkHasEdition();
      checkRecusaPorQtde();
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const content =
    activeStep === 0 ? renderContentItens() : renderContentResumo();
  if (validationCheck !== validated) setValidated(validationCheck);

  return (
    <Dialog
      maxWidth={"sm"}
      fullScreen={fullScreen}
      open={open}
      onClose={() => {
        handleClose();
        resetSelectedItens();
        setActiveStep(0);
      }}
    >
      <div>
        {activeStep > 0 && (
          <Button
            onClick={handleBack}
            color="default"
            variant="text"
            className={classes.backButton}
          >
            <ArrowBackIcon />
          </Button>
        )}
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          className={classes.steppedContent}
        >
          <Step key="0">
            <StepLabel>Itens do Pedido</StepLabel>
          </Step>
          <Step key="2">
            <StepLabel>Confirmação</StepLabel>
          </Step>
        </Stepper>
      </div>
      {content}

      {hasEdition && requireAutorizador && activeStep === 1 && (
        <Authorization
          action={handleConclusao}
          disabled={hasEdition && reason === ""}
          cancel={handleClose}
          cancelText="Fechar"
          actionText="Sim"
          endIcon={<CheckIcon />}
        />
      )}

      {!(hasEdition && requireAutorizador && activeStep === 1) && (
        <DialogActions className={classes.action}>
          <Box flexGrow={1} display="flex" p={0}>
            <Box flexGrow={1}>
              <Button
                onClick={() => {
                  handleClose();
                  resetSelectedItens();
                  setActiveStep(0);
                }}
                color="inherit"
              >
                Fechar
              </Button>
            </Box>
            <Box>
              {activeStep === 0 && (
                <Button
                  disabled={
                    (selectedItens.length !== itens.length &&
                      recusar === false) ||
                    !validated ||
                    !!selectedItens.find((s) => s.quantidade == null)
                  }
                  onClick={recusar ? handlerRecusa : handleNext}
                  variant="contained"
                  color={"primary"}
                  className={clsx(
                    recusar ? classes.buttonRecusar : classes.buttonOk
                  )}
                  endIcon={<ArrowForwardIcon />}
                >
                  {recusar ? "Recusar" : "Confirmar"}
                </Button>
              )}
              {activeStep === 1 && (
                <Button
                  onClick={() => {
                    handleConclusao();
                  }}
                  variant="contained"
                  className={classes.buttonOk}
                  endIcon={<CheckIcon />}
                  color={"primary"}
                  disabled={hasEdition && reason == ""}
                >
                  Sim
                </Button>
              )}
            </Box>
          </Box>
        </DialogActions>
      )}
    </Dialog>
  );
}
